import React from 'react';

const ServiceFormModal = ({
  isDialogOpen,
  editingService,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
  branches,
  modalities,
  equipments,
}) => {
  if (!isDialogOpen) return null;

  const title = editingService ? 'Editar Servicio' : 'Crear Nuevo Servicio';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleCalendarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      calendar_settings: {
        ...prev.calendar_settings,
        [name]: parseFloat(value),
      },
    }));
  };

  const handleEquipmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const options = Array.from(e.target.selectedOptions, (option) => option.value);
    setFormData((prev) => ({
      ...prev,
      fk_equipments: options,
    }));
  };

  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass = 'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:outline-none focus:ring';

  return (
    <div className="fixed text-white inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-primary-dark max-w-2xl rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">

          <div className="grid grid-cols-2 gap-4">

            {/* Nombre del Servicio */}
            <div className="col-span-2">
              <label className="block text-sm font-medium">Nombre del Servicio</label>
              <input type="text" name="name" value={formData.name} onChange={handleFieldChange} className={inputClass} required />
            </div>

            {/* Selector de Sucursal */}
            <div>
              <label className="block text-sm font-medium">Sucursal</label>
              <select name="fk_branch" value={formData.fk_branch} onChange={handleFieldChange} className={selectClass} required disabled={!!editingService}>
                <option value="">Selecciona Sucursal</option>
                {branches.map((b) => (<option key={b._id} value={b._id}>{b.name}</option>))}
              </select>
            </div>

            {/* Selector de Modalidad */}
            <div>
              <label className="block text-sm font-medium">Modalidad</label>
              <select name="fk_modality" value={formData.fk_modality} onChange={handleFieldChange} className={selectClass} required disabled={!!editingService}>
                <option value="">Selecciona Modalidad</option>
                {modalities.map((m) => (<option key={m._id} value={m._id}>{m.name} ({m.dicom_code})</option>))}
              </select>
            </div>

            {/* Equipos */}
            <div className="col-span-2">
              <label className="block text-sm font-medium">Equipos Compatibles (Selección Múltiple)</label>
              <select name="fk_equipments" value={formData.fk_equipments} onChange={handleEquipmentChange} className={`${selectClass} h-32`} multiple>
                {equipments.map((e) => (<option key={e._id} value={e._id}>{e.name} ({e.model || 'N/A'})</option>))}
              </select>
            </div>

            {/* Configuración de Calendario */}
            <fieldset className="border border-gray-600 p-3 rounded col-span-2 space-y-3">
              <legend className="text-sm font-semibold px-1">Configuración de Calendario</legend>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium">Duración por defecto (min)</label>
                  <input type="number" name="default_duration_min" value={formData.calendar_settings?.default_duration_min || 30} onChange={handleCalendarChange} className={inputClass} min="5" required />
                </div>
                <div>
                  <label className="block text-sm font-medium">Máx. Pacientes por Espacio</label>
                  <input type="number" name="max_patients_per_slot" value={formData.calendar_settings?.max_patients_per_slot || 1} onChange={handleCalendarChange} className={inputClass} min="1" required />
                </div>
              </div>
            </fieldset>

            {/* Estado */}
            <div className="col-span-2 flex items-center gap-6 pt-2">
              <label className="flex items-center space-x-2 text-sm">
                <input type="checkbox" name="status" checked={formData.status} onChange={handleFieldChange} />
                <span>Activo/Inactivo</span>
              </label>
            </div>

          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button type="button" onClick={resetForm} className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500">Cancelar</button>
            <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900">
              {editingService ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ServiceFormModal;
